// React related imports
import { FC } from 'react';
import { Controller } from 'react-hook-form';

// Components
import { Input } from '@GxT-Team/gxt-components';
import InputError from '../../../../../components/inputError/InputError';

// Types
import { IAuthoringFields } from './types';

const modelOptions = [
  { id: 'gnn-legacy', value: 'GNN_LEGACY', label: 'GNN (Legacy)' },
  { id: 'gnn', value: 'GNN', label: 'GNN' },
  { id: 'llm', value: 'LLM', label: 'LLM' },
] as const;

const StartAuthoringFields: FC<IAuthoringFields> = ({ control, errors }) => {
  const isStaging = process.env.REACT_APP_ENVIRONMENT === 'staging';
  return (
    <form className="flex flex-col items-start gap-6 w-[50rem]">
      <div className="flex flex-col items-start gap-2 self-stretch">
        <Controller
          name="documentName"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              inputSize={'small'}
              label={'Document Name*'}
              primary
              placeholder="Document Name"
              error={!!errors['documentName']?.message}
              helpText={<InputError errors={errors} field={'documentName'} />}
            />
          )}
        />
      </div>
      <div className="flex flex-col items-start gap-2 self-stretch w-1/2">
        <Controller
          name="version"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              inputType={'number'}
              min={0}
              step={0.1}
              inputSize={'small'}
              label={'Version*'}
              primary
              placeholder="1.00"
              error={!!errors['version']?.message}
              helpText={<InputError errors={errors} field={'version'} />}
            />
          )}
        />
      </div>

      {isStaging && (
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium">Model Type*</label>
          <div className="flex gap-4">
            <Controller
              name="modelType"
              control={control}
              defaultValue="GNN"
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  {modelOptions.map(({ id, value, label }) => (
                    <div key={id} className="flex items-center gap-2">
                      <input
                        type="radio"
                        id={id}
                        value={value}
                        checked={field.value === value}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          field.onChange(e.target.value)
                        }
                        className="h-4 w-4 border-gray-300 text-primary-600 focus:ring-primary-600"
                      />
                      <label htmlFor={id} className="text-sm text-gray-700">
                        {label}
                      </label>
                    </div>
                  ))}
                </>
              )}
            />
          </div>
          {errors['modelType']?.message && <InputError errors={errors} field={'modelType'} />}
        </div>
      )}
    </form>
  );
};

export default StartAuthoringFields;
